import { Component } from '@angular/core';


@Component({
    template: '<h2 style="text-align: center; color: red">Page Cannot Be Found</h2>',
    standalone: false
  })
export class PageNotfoundComponent {
}
